export type StaRedirectParams = {
  pluginName: Nullable<string>
  moduleName: Nullable<string>
  [key: string]: any
}

export type LegacyMenuItem = {
  children: LegacyMenuItem[]
  moduleName: Nullable<string>
  pluginName: string
  text: string
}

export type LegacyMenuConfiguration = {
  legacyMenuItems: LegacyMenuItem[]
}

export enum RunningPlayer {
  None,
  Survey,
  Ces,
}

export type StaPlayerMessageData = {
  origin: string
  command: StaPlayerCommand
}

type StaPlayerCommand = {
  name: string
  params: any
}

export enum SupportedStaPlayersOrigins {
  Survey = 'STA_SURVEY',
  CES = 'STA_CES',
}
